import { logError } from '@zg-rentals/log-error';

const minWidths = {
  xs: 0,
  sm: 321,
  md: 481,
  lg: 769,
  xl: 1024,
  xxl: 1281,
};

const screenSize = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: 'xxl',
};

const screenType = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

const browserUtils = {
  minWidths,
  screenSize,
  screenType,
  removeElementById(id: string) {
    try {
      const elem = document.getElementById(id);
      if (elem && elem?.parentNode?.contains(elem)) {
        elem.remove();
      }
    } catch (error) {
      logError({ error, context: 'browserUtils.removeElementById' });
    }
  },
  screen: {
    width() {
      if (typeof window !== 'undefined') {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      }
      return null;
    },
    size() {
      const width = browserUtils.screen.width();

      if (!width) {
        return null;
      }

      if (width < minWidths.sm) {
        return screenSize.XS;
      }
      if (width < minWidths.md) {
        return screenSize.SM;
      }
      if (width < minWidths.lg) {
        return screenSize.MD;
      }
      if (width < minWidths.xl) {
        return screenSize.LG;
      }
      if (width < minWidths.xxl) {
        return screenSize.XL;
      }
      if (width >= minWidths.xxl) {
        return screenSize.XXL;
      }
      return null;
    },
    type() {
      const size = browserUtils.screen.size();

      switch (size) {
        case screenSize.XS:
        case screenSize.SM:
          return screenType.MOBILE;
        case screenSize.MD:
        case screenSize.LG:
          return screenType.TABLET;
        case screenSize.XL:
        case screenSize.XXL:
          return screenType.DESKTOP;
        default:
          return null;
      }
    },
  },
  timezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  },
};

browserUtils.screen.width = browserUtils.screen.width.bind(browserUtils);
browserUtils.screen.size = browserUtils.screen.size.bind(browserUtils);
browserUtils.screen.type = browserUtils.screen.type.bind(browserUtils);

export { screenSize };

export default browserUtils;
